import { IRoles } from "../models/iRoles";
import { ServerProvider } from "../providers/server-provider";

/**
 * Clase que proporcina atributos y funciones comunes a todas las vistas
 */
export abstract class BaseViewComponent {
    public userRoles:IRoles;

    constructor(){
        
    }

    protected ionViewDidLoad(){
        this.loadUserRoles();
    }
    

    public loadUserRoles(){
        
        //carga los roles del usuario
        if(ServerProvider.myApp.userLogin && ServerProvider.myApp.userLogin.roles){
            this.userRoles = ServerProvider.myApp.userLogin.roles;

        }
        
    }
}


// WEBPACK FOOTER //
// ./src/components/baseViewComponent.ts